import { defineMessages } from '@jutro/locale';

export default defineMessages({
    tellWhoAreNotListed: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.Tell us about any additional household members who are not listed',
        defaultMessage: 'Tell us about any additional household members who are not listed'
    },
    tellWhoAreNotListedNP: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.Tell us about any additional non drivers who are not listed',
        defaultMessage: 'Tell us about any additional non drivers who are not listed'
    },
    peopleDoNotDriveOrHaveOtherInsurance: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.The following people live in your household but do not drive or have other insurance',
        defaultMessage: 'The following people live in your household but do not drive or have other insurance'
    },
    edit: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.Edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.Remove',
        defaultMessage: 'Remove'
    },
    howToChangeFromExcluded: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.How to change from excluded',
        defaultMessage: 'How to change from excluded?'
    },
    excludedDriverHelpTextMsg: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.excluded driver help text message',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to a household member, click on Remove and select the applicable reason.'
    },
    howToChangeFromHouseholdMember: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.How to change from household member',
        defaultMessage: 'How to change from household member?'
    },
    householdMemberHelpTextMsg: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.household member help text message',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver.  To change to an excluded driver, click on Remove and select the applicable reason.'
    },
    whatDoesThisMean: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.What does this mean',
        defaultMessage: 'What does this mean?'
    },
    driverWillBeExcludedFromLiabilityCov: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.The driver will be excluded from liability coverage under this policy',
        defaultMessage: 'The driver will be excluded from liability coverage under this policy.'
    },
    belowDriversExcluded: {
        id: 'ml.gateway.MLVehicleOperatorTableComponent.Below are the members of the household which are excluded',
        defaultMessage: 'Below are the members of the household which are excluded'
    },
    
});
